import { ReactComponent as ZIcon } from './imgs/extensions/ic_7z.svg';
import { ReactComponent as ARJIcon } from './imgs/extensions/ic_ARJ.svg';
import { ReactComponent as BMPIcon } from './imgs/extensions/ic_BMP.svg';
import { ReactComponent as DOCIcon } from './imgs/extensions/ic_DOC.svg';
import { ReactComponent as GIFIcon } from './imgs/extensions/ic_GIF.svg';
import { ReactComponent as JPGIcon } from './imgs/extensions/ic_JPG.svg';
import { ReactComponent as ODTIcon } from './imgs/extensions/ic_ODT.svg';
import { ReactComponent as PDFIcon } from './imgs/extensions/ic_PDF.svg';
import { ReactComponent as PNGIcon } from './imgs/extensions/ic_PNG.svg';
import { ReactComponent as RARIcon } from './imgs/extensions/ic_RAR.svg';
import { ReactComponent as TIFIcon } from './imgs/extensions/ic_TIF.svg';
import { ReactComponent as TXTIcon } from './imgs/extensions/ic_TXT.svg';
import { ReactComponent as XLSIcon } from './imgs/extensions/ic_XLS.svg';
import { ReactComponent as ZIPIcon } from './imgs/extensions/ic_ZIP.svg';
import React from 'react';

export function getExtensionImage(fileType, className = '') {
  let ImageIcon = () => null;
  if (fileType.match(/.*?(7z)$/gi)) {
    ImageIcon = ZIcon;
  }
  if (fileType.match(/.*?(ARJ)$/gi)) {
    ImageIcon = ARJIcon;
  }
  if (fileType.match(/.*?(BMP)$/gi)) {
    ImageIcon = BMPIcon;
  }
  if (fileType.match(/.*?(document|DOC|DOCX)$/gi)) {
    ImageIcon = DOCIcon;
  }
  if (fileType.match(/.*?(GIF)$/gi)) {
    ImageIcon = GIFIcon;
  }
  if (fileType.match(/.*?(JPG|JPEG)$/gi)) {
    ImageIcon = JPGIcon;
  }
  if (fileType.match(/.*?(ODT)$/gi)) {
    ImageIcon = ODTIcon;
  }
  if (fileType.match(/.*?(PDF)$/gi)) {
    ImageIcon = PDFIcon;
  }
  if (fileType.match(/.*?(PNG)$/gi)) {
    ImageIcon = PNGIcon;
  }
  if (fileType.match(/.*?(RAR)$/gi)) {
    ImageIcon = RARIcon;
  }
  if (fileType.match(/.*?(TIF|TIFF)$/gi)) {
    ImageIcon = TIFIcon;
  }
  if (fileType.match(/.*?(TXT)$/gi)) {
    ImageIcon = TXTIcon;
  }
  if (fileType.match(/.*?(sheet|XLS|XLSX)$/gi)) {
    ImageIcon = XLSIcon;
  }
  if (fileType.match(/.*?(ZIP)$/gi)) {
    ImageIcon = ZIPIcon;
  }
  return <ImageIcon width={20} fill={'white'} className={className} />;
}
